import React from "react";
import { Select, Button, Input, DatePicker, Icon } from "antd";
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import dictCache from '../../../common/dictCache';
import SearchRetrieve from '../../common/SearchRetrieve.new';
import moment from "moment";

const monthFormat = 'YYYY-MM';
const { Option } = Select;
const { MonthPicker } = DatePicker;
const roleList = [
    { label: 'PM', value: 'PM' },
    { label: 'PA', value: 'PA' },
    { label: 'CRC', value: 'CRC' },
    { label: 'CRCC', value: 'CRCC' },
    { label: 'CRCM', value: 'CRCM' },
    { label: 'PML', value: 'PML' },
];

class Filter extends React.Component {
    state = {
        expand: false,
        areaList: [],
        optionalMonths: [],
    }

    componentDidMount() {
        this.getDate();
        this.loadTypeConfigureList();
    }

    search = () => {
        this.props.search();
    }

    getDate = () => {
        dictCache.getDict('EFFECTIVE_DATE', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.home.queryEffectiveDate,
                data: {},
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            const { date } = res;
            const list = [];
            for (let index = 0; index < 4; index++) {
                list.push(moment(date).add(-index, 'M').format('YYYYMM'));
            }
            this.setState({ optionalMonths: list });
        });
    }

    loadTypeConfigureList = () => {
        dictCache.getDict('TYPE_CONFIGURE', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.common.typeConfigureList,
                data: {},
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            this.setState({ areaList: res.areaList });
        });
    }

    handleChange = (value, key) => {
        const { searchParams, onChange } = this.props;
        switch (key) {
            case 'lineOfBusinessIds':
                searchParams[key] = value ? value.join(',') : undefined;
                searchParams.secondLineName = undefined;
                onChange(searchParams);
                break;
            case 'investigationAreaId':
                searchParams[key] = value;
                searchParams.diseaseId = undefined;
                searchParams.diseaseName = undefined;
                onChange(searchParams);
                break;
            case 'disease': {
                const { value: id, text: name } = value;
                searchParams[`${key}Id`] = id;
                searchParams[`${key}Name`] = name;
                onChange(searchParams);
                break;
            }
            default:
                searchParams[key] = value;
                onChange(searchParams);
                break;
        }
    }

    enterSearch = e => {
        if (e.charCode === 13) {
            this.search();
        }
    }

    reset = () => {
        this.props.reset();
    }

    disabledDate = (current) => {
        const { optionalMonths } = this.state;
        return !(optionalMonths || []).some(el => el == current.format('YYYYMM'))
    }

    toggleHeight = () => {
        this.setState((prevState) => ({
            expand: !prevState.expand,
        }));
    }

    render() {
        const { businessList, searchParams } = this.props;
        const { expand, areaList } = this.state;
        const {
            monthNum1 = null,
            monthNum2 = null,
            lineOfBusinessIds,
        } = searchParams;
        const secondLineSet = new Set();
        businessList.forEach(i => {
            const arr = (lineOfBusinessIds || '').split(',');
            if (arr.some(j => j == i.typeConfigureId)) {
                (i.childList || []).forEach(j => secondLineSet.add(j.typeValue));
            }
        });

        const businessOption = businessList.map(i => <Option key={i.typeConfigureId}>{i.typeValue}</Option>);
        const secondLineOption = [...secondLineSet].map(i => <Option key={i}>{i}</Option>);
        const areaListOption = areaList.map(d => <Option key={String(d.investigationAreaId)} title={d.investigationAreaName}>{d.investigationAreaName}</Option>);
        const roleOption = roleList.map(d => <Option key={d.value}>{d.label}</Option>);
        const { curRole } = sessionStorage;
        return (
            <div style={{marginBottom: 16}}>
                <div className={`search-bar expand ${expand ? 'expanded' : ''}`}>
                    <div className="expand-box">
                        <a onClick={this.toggleHeight}>
                            {expand ? "收起" : "展开"}
                            <Icon className="expand-icon" type={expand ? "up" : "down"} />
                        </a>
                    </div>
                    <div className="search-item">
                        <label htmlFor="" className="ui-label">时间</label>
                        <MonthPicker
                            format={monthFormat}
                            style={{width: 100}}
                            value={monthNum1 ? moment(monthNum1) : null}
                            disabledDate={curRole == 'CRC' ? this.disabledDate : undefined}
                            placeholder="选择月份"
                            onChange={(date, dateString) => this.handleChange(dateString, 'monthNum1')}
                        />
                    </div>

                    <div className="search-item">
                        <label htmlFor="" className="ui-label">至</label>
                        <MonthPicker
                            format={monthFormat}
                            style={{width: 100}}
                            value={monthNum2 ? moment(monthNum2) : null}
                            disabledDate={curRole == 'CRC' ? this.disabledDate : undefined}
                            placeholder="选择月份"
                            onChange={(date, dateString) => this.handleChange(dateString, 'monthNum2')}
                        />
                    </div>
                    <div className="search-item">
                        <label htmlFor="" className="ui-label">项目编号</label>
                        <Input
                            style={{width: 120}}
                            placeholder="请输入"
                            value={searchParams.investigationCode}
                            onChange={e => this.handleChange(e.target.value, 'investigationCode')}
                            onKeyPress={this.enterSearch}
                        />
                    </div>
                    <div className="search-item">
                        <label htmlFor="" className="ui-label">项目简称</label>
                        <Input
                            placeholder="请输入"
                            value={searchParams.investigationName}
                            onChange={e => this.handleChange(e.target.value, 'investigationName')}
                            onKeyPress={this.enterSearch}
                        />
                    </div>
                    <div className="search-item">
                        <label htmlFor="" className="ui-label">中心编号</label>
                        <Input
                            style={{width: 120}}
                            placeholder="请输入"
                            value={searchParams.investigationSiteCode}
                            onChange={e => this.handleChange(e.target.value, 'investigationSiteCode')}
                            onKeyPress={this.enterSearch}
                        />
                    </div>
                    <div className="search-item">
                        <label htmlFor="" className="ui-label">中心名称</label>
                        <Input
                            placeholder="请输入"
                            value={searchParams.investigationSiteName}
                            onChange={e => this.handleChange(e.target.value, 'investigationSiteName')}
                            onKeyPress={this.enterSearch}
                        />
                    </div>
                    <div className="search-item">
                        <label htmlFor="" className="ui-label">业务线</label>
                        <Select
                            mode="multiple"
                            allowClear={true}
                            filterOption={false}
                            placeholder="请选择"
                            style={{width: 120}}
                            value={lineOfBusinessIds ? lineOfBusinessIds.split(',') : []}
                            className="multiple-stage"
                            onChange={value => this.handleChange(value, 'lineOfBusinessIds')}
                        >
                            {businessOption}
                        </Select>
                    </div>
                    <div className="search-item">
                        <label className="ui-label">执行业务线二级分类</label>
                        <Select
                            allowClear={true}
                            placeholder="请选择"
                            style={{width: 120}}
                            disabled={!lineOfBusinessIds}
                            value={searchParams.secondLineName}
                            onChange={value => this.handleChange(value, 'secondLineName')}
                        >
                            {secondLineOption}
                        </Select>
                    </div>
                    <div className="search-item">
                        <label htmlFor="" className="ui-label">项目领域</label>
                        <Select
                            placeholder="请选择"
                            allowClear={true}
                            value={searchParams.investigationAreaId}
                            style={{ width: 120 }}
                            onChange={value => this.handleChange(value, 'investigationAreaId')}
                        >
                            {areaListOption}
                        </Select>
                    </div>
                    <div className="search-item">
                        <label htmlFor="" className="ui-label">疾病</label>
                        <SearchRetrieve
                            keyword='keyword'
                            style={{ width: 140 }}
                            params={{ investigationAreaId: searchParams.investigationAreaId }}
                            placeholder="输入名称检索"
                            url={API_URL.common.queryAllDisease}
                            value={searchParams.diseaseName}
                            config={{ id: 'diseaseId', name: 'diseaseName' }}
                            onChange={(option) => this.handleChange(option, 'disease')}
                        />
                    </div>
                    <div className="search-item">
                        <label htmlFor="" className="ui-label">角色</label>
                        <Select
                            placeholder="请选择"
                            allowClear={true}
                            value={searchParams.roleCode}
                            style={{ width: 80 }}
                            onChange={value => this.handleChange(value, 'roleCode')}
                        >
                            {roleOption}
                        </Select>
                    </div>
                </div>
                <div className="search-bar flex-end">
                    <div className="search-item">
                        <Button type="primary" onClick={this.search}>搜索</Button>
                        <Button type="primary" onClick={this.reset}>重置</Button>
                        {this.props.showback && <Button type="primary" onClick={this.props.goBack} className='back'>返回</Button>}
                    </div>
                </div>
            </div>
        );
    }
}

export default Filter;



// WEBPACK FOOTER //
// ./src/components/manHour/monthlyFte/Filter.js